import http from "../../http-common"


const loadCorridors = async(token) => {
    const response = await http.post('/corridorData', {"token":token}).then((response) => {
        return response
    })
    let corrList = await response
    console.log(corrList)
    return corrList
}


export default loadCorridors;
